/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class UserApi {
    static getInstance() {
        if (!this.instance) this.instance = new UserApi()
        return this.instance
    }

    // 通用请求
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 用户信息列表
    async getUserList(param, page_num, page_size){
        let url = `/api/sys/users/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url, param, 'POST')
        return result
    }

    // 登录日志列表
    async getSignLogList(param, page_num, page_size){
        let url = `/api/sys/signlog/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url, param, 'POST')
        return result
    }

    // 隐私协议版本列表
    async getVersionList (param, page_num, page_size){
        let url = `/api/users/privacy/sys/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增隐私协议版本登录记录列表
    async getVersionLoginRecordList (param, page_num, page_size){
        let url = `/api/users/privacy/record/sys/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }
}

export {
    UserApi
}


